export const paths = {
    assetImages: '/assets/images',
    thumbnails: '160x120',
    searchRepoUrl: 'resources/search'
};
